{
  "account": {
    "darkMode": "Dark Mode",
    "profileInformation": "Profile Information",
    "role": "Role",
    "sandboxSection": "Sandbox Section",
    "settings": "Settings",
    "title": "Account",
    "userRole": "User Role"
  },
  "calendars": {
    "addButton": "Add Event",
    "eventBox": {
      "observers": "{{count}} Observers",
      "students": "{{count}} Students"
    },
    "filters": {
      "instructors": "Instructors",
      "isCancelledShown": "Show Cancelled Events",
      "lessons": "Lessons",
      "locations": "Locations",
      "students": "Students",
      "title": "Calendar Filters"
    },
    "publish": {
      "cta": "Publish {{view}}",
      "dialogDescription": "This will send an email to all affected students and instructors.",
      "dialogTitleWithCancelled_one": "Are you sure you want to publish the 1 unpublished event ({{cancelledCount}} cancelled)?",
      "dialogTitleWithCancelled_other": "Are you sure you want to publish the {{count}} unpublished events ({{cancelledCount}} cancelled)?",
      "dialogTitle_one": "Are you sure you want to publish the 1 unpublished events?",
      "dialogTitle_other": "Are you sure you want to publish the {{count}} unpublished events?",
      "publishedEventsWithCancelled_one": "1 Published Event in {{campus}} this {{view}} <b>({{cancelledCount}} cancelled)</b>",
      "publishedEventsWithCancelled_other": "{{count}} Published Events in {{campus}} this {{view}} <b>({{cancelledCount}} cancelled)</b>",
      "publishedEvents_one": "1 Published Event in {{campus}} this {{view}}",
      "publishedEvents_other": "{{count}} Published Events in {{campus}} this {{view}}",
      "unpublishedEventsWithCancelled_one": "1 Unpublished Event in {{campus}} this {{view}} <b>({{cancelledCount}} cancelled)</b>",
      "unpublishedEventsWithCancelled_other": "{{count}} Unpublished Events in {{campus}} this {{view}} <b>({{cancelledCount}} cancelled)</b>",
      "unpublishedEvents_one": "1 Unpublished Event in {{campus}} this {{view}}",
      "unpublishedEvents_other": "{{count}} Unpublished Events in {{campus}} this {{view}}"
    },
    "selector": "Select a Campus or any other filter to view Calendar",
    "timezones": {
      "atlantic": "Atlantic Timezone",
      "eastern": "Eastern Timezone",
      "local": "Device Time"
    },
    "title": "Calendars"
  },
  "classrooms": {
    "filters": {
      "title": "Classroom Filters"
    },
    "title": "Classrooms"
  },
  "courseForm": {
    "createTitle": "Add Course",
    "updateTitle": "Edit Course"
  },
  "courses": {
    "achievements": "Achievements",
    "active": "Active",
    "addButton": "Add Course",
    "campuses": "Campuses",
    "deactivate": "Deactivate",
    "deactivateDialog": {
      "cancelButton": "Cancel",
      "confirmButton": "Deactivate",
      "description": "Deactivating this course will prevent new registrations from being created against it. Existing enrolments will not be affected.",
      "title": "Deactivate Course"
    },
    "details": {
      "invoiceTemplate": "Invoice Template",
      "title": "Course Details"
    },
    "documentsRequired": "Documents Required",
    "duration": "Duration",
    "inactive": "Inactive",
    "reactivate": "Reactivate",
    "reactivateDialog": {
      "cancelButton": "Cancel",
      "confirmButton": "Reactivate",
      "description": "Reactivating this course will allow new registrations to be created against it.",
      "title": "Reactivate Course"
    },
    "registered": "Registered",
    "search": "Search Courses",
    "title": "Course",
    "toasts": {
      "deactivateSuccess": "Course deactivated successfully.",
      "reactivateSuccess": "Course reactivated successfully."
    },
    "unregistered": "Unregistered"
  },
  "dashboard": {
    "help": {
      "caption": "This address is monitored by the development team and TTCC leadership. While we may not respond to every message, we review all feedback carefully.",
      "description": "If you encounter any issues while using the system, have questions, or would like to suggest improvements, please email us at:",
      "title": "Need Help or Have Feedback?"
    },
    "title": "Dashboard"
  },
  "discardFormChangesDialog": {
    "cancelButton": "Back to editing",
    "confirmButton": "Leave anyway",
    "creating": "creating",
    "description": "There are unsaved changes to the {{entity}} you are {{action}}. If you leave this page you will lose your progress.",
    "entity": "entity",
    "title": "Are you sure you want to leave?",
    "updating": "editing"
  },
  "documentTypes": {
    "addButton": "Add Document Type",
    "entity": "document type",
    "form": {
      "createTitle": "Add Document Type",
      "errors": {
        "duplicateName": "A document type with this name already exists."
      },
      "namePlaceholder": "Enter document type name",
      "updateTitle": "Edit Document Type"
    },
    "title": "Document Types",
    "toasts": {
      "createSuccess": "Document type created successfully",
      "updateSuccess": "Document type updated successfully"
    }
  },
  "emailChangeDialog": {
    "description": "This action will change the email address for this {{userType}} to <bold>{{email}}</bold> and they will no longer be able to log in with their previous email address.",
    "staff": "staff member",
    "student": "student",
    "title": "Are you sure you want to change this {{userType}}'s email?"
  },
  "enrolments": {
    "details": {
      "achievements": "Achievements",
      "addEvent": "Event",
      "averageLessonGrades": "Average Lesson Grades",
      "cancelButton": "Cancel Enrolment",
      "certificate": {
        "certificateDate": "Certificate Date",
        "diplomaLabel": "Diploma Date: {{date}}",
        "downloadButton": "Download Certificate",
        "failed": "Failed on: {{date}}",
        "overrideEndDate": " Override: {{date}}\n(will be used on Certificate)",
        "sent": "Certificate sent: {{date}}",
        "title": "Certificate",
        "toast": {
          "certificateDownloaded": "Certificate downloaded",
          "failedCertificateDownload": "Failed to download certificate",
          "sent": "Certificate sent"
        }
      },
      "contract": {
        "addButton": "Create Contract",
        "label": {
          "notSent": "Not sent"
        },
        "notSent": "All sections are complete.",
        "sent": "Contract sent: {{date}}",
        "signDisabledHint": "The contract can't be signed until the invoices total the course cost. Adjust the real invoices to balance before signing.",
        "signed": "Contract signed: {{date}}",
        "title": "Contract",
        "toast": {
          "created": "Contract created",
          "notSent": "Contract updated",
          "sent": "Contract sent",
          "signBalanceError": "The contract can't be signed until the real invoices total the course cost. Adjust the invoices to balance before signing.",
          "signed": "Contract signed",
          "updateError": "Unable to update contract. Please try again."
        }
      },
      "courseContent": "Course Content",
      "createNewEvent": "Create New Event",
      "deleteDocumentDialog": {
        "description": "Are you sure you want to delete this document?",
        "title": "Delete Document"
      },
      "documentStatus": {
        "approved": "Approved",
        "notReceived": "Not Received",
        "received": "Received",
        "rejected": "Rejected"
      },
      "documentViewer": {
        "documentApproved": "Document Approved",
        "documentRejected": "Document Rejected",
        "nextPage": "Next Page",
        "noDocuments": "Document not available",
        "previousPage": "Previous Page",
        "title": "Documents Viewer"
      },
      "eventListTitle": "Events",
      "finalMark": "Final Mark",
      "invoice": {
        "markSentButton": "Mark Invoice as Sent",
        "realInvoicesExist": "This enrolment already has {{count}} invoice(s). This flag tracks only a placeholder and does not affect them.",
        "status": {
          "cancelled": "Cancelled",
          "draft": "Pending",
          "due": "Due",
          "overdue": "Overdue",
          "paid": "Paid",
          "partial": "Partial"
        },
        "title": "Invoice Status",
        "undoButton": "Invoice Sent (Click to Undo)"
      },
      "labels": {
        "campus": "Associated campuses",
        "course": "Course",
        "endDate": "End Date",
        "notes": "Notes",
        "startDate": "Start Date",
        "student": "Student"
      },
      "melt": {
        "description": "Date enrolment was sent to MELT.",
        "title": "MELT"
      },
      "noAchievements": "There are no achievements for this course.",
      "noEvaluations": "No evaluations available",
      "notes": {
        "addButton": "Add Note",
        "placeholder": "Enter note...",
        "title": "Notes",
        "viewAll": "View All {{count}}"
      },
      "payment": {
        "amountError": "Amount must be a valid number",
        "cancelButton": "Cancel Payment",
        "decimalError": "Amount must have at most two decimal places",
        "description": "Payments will show up here once they are added.",
        "details": {
          "title": "Payment Details"
        },
        "errors": {
          "invoiceEnrolmentMismatch": "Invoice does not belong to this enrolment"
        },
        "label": {
          "amount": "Amount",
          "enrolmentPrice": "Enrolment Price",
          "outstandingBalance": "Outstanding Balance",
          "totalPaid": "Total Paid"
        },
        "picker": {
          "invoiceLabel": "Invoice",
          "invoiceOption": "Invoice #{{number}} — {{payerName}} ({{status}}) — Outstanding {{outstanding}}",
          "invoicePlaceholder": "Select an invoice",
          "invoiceRequired": "Please select an invoice",
          "payerEmpty": "—",
          "payerLabel": "Payer",
          "placeholderOption": "Placeholder — {{payerName}} — Outstanding {{outstanding}}",
          "placeholderOptionEmpty": "Placeholder — Catch-all"
        },
        "placeholder": {
          "amount": "$0000.00",
          "paymentType": "Payment type"
        },
        "receiptButton": "Download Receipt",
        "saveButton": "Add Payment",
        "title": "Payments",
        "toasts": {
          "cancelled": "Payment cancelled successfully",
          "success": "Payment created successfully",
          "update": "Payment updated successfully"
        },
        "type": {
          "bank": "Bank Transfer",
          "cash": "Cash",
          "check": "Check",
          "creditCard": "Credit Card",
          "emailMoneyTransfer": "E-Transfer",
          "other": "Other"
        }
      },
      "progress": {
        "completedLessons": "Completed",
        "recalculateButton": "Recalculate Progress",
        "rescheduledLessons": "Rescheduled",
        "scheduledLessons": "Scheduled",
        "title": "Enrolment Progress",
        "unscheduledLessons": "Unscheduled",
        "unsignedLessons": "Unsigned"
      },
      "rejectDocumentDialog": {
        "placeholder": "Please provide a reason for rejecting this document",
        "rejectButton": "Reject Document",
        "subtitle": "You are about to reject the <b>{{documentTypeName}}</b> document",
        "title": "Reject Document"
      },
      "rejectionReason": "Rejection Reason",
      "restoreButton": "Restore Enrolment",

      "title": "Enrolment Details",
      "toasts": {
        "progressCalculated": "Enrolment progress calculated successfully",
        "progressCalculatedMissingIds": "No enrollment IDs provided",
        "progressCalculationStarted": "Enrolment progress calculation started for large batch",
        "updateAchievementError": "There was an error updating achievements",
        "updateAchievementSuccess": "Achievements successfully updated",
        "updateDocumentTypeStatusSuccess": "Document status successfully updated"
      },
      "transcript": {
        "certificateDate": "Certificate Date",
        "diplomaLabel": "Diploma Date: {{date}}",
        "downloadButton": "Download Transcript",
        "manualDiplomaDate": "Override End Date",
        "overrideEndDate": " Override: {{date}}\n(will be used on transcript)",
        "sent": "Transcript sent: {{date}}",
        "title": "Transcript",
        "toast": {
          "failedTranscriptDownload": "Failed to generate transcript",
          "sent": "Transcript status updated",
          "transcriptDownloaded": "Transcript downloaded successfully"
        }
      },
      "upcomingEvents": "Upcoming Events",
      "viewRegistrationDetails": "View Registration Details"
    },
    "entity": "Enrolment",
    "filters": {
      "labels": {
        "course": "Courses",
        "status": "Status"
      },
      "title": "Enrolment Filters"
    },
    "generalDocuments": {
      "addDialog": {
        "filesCount": "{{count}} file(s) selected",
        "filesLabel": "Files",
        "nameLabel": "Document Name",
        "namePlaceholder": "Enter document name...",
        "title": "Upload General Document",
        "uploadButton": "Choose Files"
      },
      "description": "Uploaded on: {{date}}",
      "empty": "There are no General Documents uploaded",
      "toasts": {
        "createSuccess": "Document uploaded successfully",
        "failedUpload": "Failed to upload document"
      },
      "upload": "Upload Document"
    },
    "notes": {
      "toasts": {
        "createSuccess": "Note added successfully",
        "updateSuccess": "Note updated successfully"
      }
    },
    "paymentStatus": {
      "on_track": "On track",
      "outstanding": "Outstanding",
      "overdue": "Overdue",
      "paid": "Paid"
    },
    "search": "Search Enrolments",
    "status": {
      "active": "Active",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "pending": "Pending",
      "uncompleted": "Uncompleted"
    },
    "table": {
      "header": {
        "campus": "Campus",
        "completedLessons": "Completed Lessons",
        "course": "Course",
        "endDate": "End Date",
        "invoice": "Inv.",
        "outstanding": "Outstanding",
        "paymentStatus": "Payment Status",
        "rescheduledLessons": "Rescheduled Lessons",
        "scheduledLessons": "Scheduled Lessons",
        "startDate": "Start Date",
        "status": "Status",
        "student": "Student",
        "unscheduledLessons": "Unscheduled Lessons",
        "unsignedLessons": "Unsigned Lessons"
      }
    },
    "title": "Enrolments",
    "toasts": {
      "activateSuccess": "{{name}}'s account has been activated",
      "createSuccess": "Enrolment created successfully!",
      "deactivateSuccess": "{{name}}'s account has been deactivated"
    }
  },
  "errorFallback": {
    "description": "An error occurred while loading the page.",
    "resetCta": "Try again",
    "title": "Error"
  },
  "events": {
    "cancel": {
      "published_description": "Are you sure you want to cancel this event?\nIf this event is cancelled, an email will be sent to all Students.",
      "title": "Cancel Event",
      "unpublished_description": "Are you sure you want to cancel this event?"
    },
    "details": {
      "activities": {
        "updateActivities": "Update Activities"
      },
      "addEvent": "Event",
      "badges": {
        "cancelled": "Cancelled",
        "finished": "Finished",
        "observer": "Observation",
        "partDone": "Part Done"
      },
      "createNewEvent": "Create New Event",
      "errors": {
        "duplicateStudents": "The same enrolment cannot be both a student and an observer."
      },
      "evaluations": {
        "isPartialEvaluation": "include details on what activities were completed in the Event Notes below",
        "noEventNotes": "No event notes added",
        "noSkills": "No skills available",
        "setCompleted": "Fully Completed",
        "setEvaluationType": "Was the event fully completed?",
        "setPartial": "Part Done",
        "startEvaluation": "Start Evaluation",
        "title": "Evaluation",
        "toasts": {
          "createError": "Failed to create evaluations",
          "createSuccess": "Evaluations created successfully!"
        }
      },
      "evaluationsNotes": "Event Notes",
      "evaluationsNotesPlaceholder": "Add notes for this evaluation",
      "eventListTitle": "Events",
      "labels": {
        "classroom": "Classroom",
        "customTime": "Use custom time",
        "date": "Date",
        "enrolment": "Enrolment",
        "instructors": "Instructors",
        "lesson": "Lesson",
        "location": "Location",
        "scheduledAt": "{{scheduledAt}} to {{scheduledEndAt}}",
        "staffNotes": "Staff Notes",
        "student": "Student",
        "studentNotes": "Student Notes"
      },
      "noObservers": "No observers enrolled in this event",
      "noSkills": "No skills assigned to this event",
      "noStudents": "No students enrolled in this event",
      "noVehicles": "No vehicles selected in this event",
      "placeholders": {
        "enrolment": "Select Enrolment",
        "instructor": "Select Instructors",
        "lesson": "Select Lesson",
        "location": "Add Event Location",
        "staffNotes": "Enter Staff Notes",
        "studentNotes": "Enter Student Notes"
      },

      "takeAttendance": "Take Attendance",
      "title": "Event Details",
      "toasts": {
        "errorStaffSignOff": "There was an error signing off, could not find current staff member",
        "updateError": "There was an error updating students",
        "updateSuccess": "Students for this event successfully updated",
        "updateVehiclesError": "There was an error updating vehicles",
        "updateVehiclesSuccess": "Vehicles for this event successfully updated"
      }
    },
    "entity": "event",
    "filters": {
      "labels": {
        "course": "Courses",
        "status": "Status"
      },
      "title": "Enrolment Filters"
    },
    "form": {
      "createButton": "Create New Event",
      "createMakeUpButton": "Create Make Up Event",
      "createSaveButton": "Add Event",
      "createTitle": "Add Event",
      "instructorEvents": "Instructor Schedule",
      "outstandingConfirmDescription": "This student has {{amount}} outstanding. Are you sure you want to create an event for them?",
      "outstandingConfirmTitle": "Schedule event for a student with a balance?",
      "outstandingWarningDescription": "This student has {{amount}} outstanding. We probably shouldn’t schedule events for them until it’s settled.",
      "outstandingWarningTitle": "Student has an outstanding balance",
      "overdueConfirmButton": "Create anyway",
      "overdueConfirmDescription": "This student has {{amount}} in overdue payments (expected {{since}}). Are you sure you want to create an event for them?",
      "overdueConfirmTitle": "Schedule event for a student behind on payments?",
      "overdueDays_one": "{{count}} day ago",
      "overdueDays_other": "{{count}} days ago",
      "overdueToday": "earlier today",
      "overdueWarningDescription": "A payment of {{amount}} was expected {{since}} and hasn’t been received yet. We probably shouldn’t schedule events for this student.",
      "overdueWarningTitle": "Student is behind on payments",
      "timeLabels": {
        "seven": "7:00 AM",
        "sixteen": "4:00 PM",
        "ten": "10:00 AM",
        "thirteen": "1:00 PM"
      },
      "upcomingEvents": "Upcoming Events"
    },
    "noEvents": "No events found",
    "plan": {
      "description": "Reference material for the lesson being taught",
      "fileName": "{{lesson}} lesson plan",
      "title": "Lesson Plan",
      "viewCta": "View Plan"
    },
    "publish": {
      "description": "Are you sure you want to publish this event?\nAn email will be sent to all Students and Instructors",
      "title": "Publish Event"
    },
    "restore": {
      "cta": "Restore",
      "description": "Are you sure you want to restore this event?\nIt will be restored to the unpublished state.",
      "title": "Restore Event"
    },
    "route": {
      "changeCta": "Change Route",
      "empty": "No route selected for this lesson yet",
      "emptyStudent": "Your instructor has not selected a route yet",
      "levels": {
        "advanced": "Advanced",
        "beginner": "Beginner",
        "expressway": "Expressway",
        "intermediate": "Intermediate"
      },
      "picker": {
        "confirm": "Select Route",
        "levelCount": "{{count}} of {{total}} levels have routes",
        "noResults": "No routes match your search",
        "noneAtLevel": "No routes at this level",
        "searchPlaceholder": "Search routes",
        "subtitle": "{{count}} routes available at {{location}}",
        "subtitleNoLocation": "{{count}} routes available",
        "title": "Select Lesson Route"
      },
      "selectCta": "Select Route",
      "title": "Lesson Route",
      "viewCta": "View Route"
    },
    "search": "Search Events",
    "signOff": {
      "instructorAlt": "Instructor Signature",
      "instructorAttendancePrevented": "Complete attendance before signing off",
      "instructorCanSign": "Sign off event to finish",
      "instructorComplete": "Signed",
      "instructorCta": "Add Instructor Sign Off",
      "instructorEvaluationPrevented": "Complete student evaluation before signing off",
      "instructorIncompleteForStudent": "Instructor has not signed off on this event",
      "instructorRoutePrevented": "Select a lesson route before signing off",
      "instructorSignatureInstructions": "Sign in the box below",
      "instructorStudentSigningPrevented": "You will be able to collect student signature once you sign off to the event",
      "instructorTitle": "Instructor Sign Off",
      "instructorVehiclePrevented": "Complete vehicles section before signing off",
      "signature": "Signature",
      "studentAlt": "Student Signature",
      "studentCta": "Add Student Sign Off",
      "studentEmpty": "No students enrolled in this event",
      "studentPrevented": "If you are marked as attended by the instructor, you will be requested to sign off.",
      "studentTitle": "Student Sign Off"
    },
    "status": {
      "cancelled": "Cancelled",
      "finished": "Finished",
      "partial": "Part Done",
      "scheduled": "Scheduled",
      "unpublished": "Unpublished"
    },
    "title": "Events",
    "toasts": {
      "cancelError": "There was an error cancelling the event",
      "cancelSuccess": "Event cancelled successfully",
      "createError": "There was an error creating the event: {{error}}",
      "createSuccess": "Event scheduled successfully!",
      "multiPublishError": "There was an error publishing the events",
      "multiPublishSuccess": "Events published successfully",
      "publishError": "There was an error publishing the event",
      "publishSuccess": "Event published successfully",
      "signatureSuccess": "Signature added successfully",
      "updateError": "There was an error updating the event",
      "updateSuccess": "Event updated successfully"
    }
  },
  "home": {
    "title": "Home Page"
  },
  "lessons": {
    "status": {
      "completed": "Completed",
      "notSigned": "Not Signed",
      "rescheduled": "Reschedule",
      "scheduled": "Scheduled",
      "unscheduled": "Unscheduled"
    }
  },
  "locations": {
    "addButton": "Add Location",
    "details": {
      "labels": {
        "address": "Address",
        "campus": "Associated campuses",
        "name": "Name",
        "status": "Status",
        "type": "Type",
        "url": "Conference Link"
      },
      "title": "Location Details"
    },
    "entity": "location",
    "filters": {
      "labels": {
        "province": "Province",
        "status": "Status"
      },
      "title": "Location Filters"
    },
    "form": {
      "createSaveButton": "Create Location",
      "createTitle": "Add Location",
      "errors": {
        "addressRequired": "Address is required",
        "typeRequired": "Type is required",
        "unableToCreate": "Unable to create location: {{error}}",
        "urlRequired": "Conference Link is required"
      },
      "placeholders": {
        "address": "Enter Physical Address",
        "campus": "Add associated campuses",
        "type": "Select type",
        "url": "Enter Conference Link"
      },
      "updateSaveButton": "Update Location",
      "updateTitle": "Edit Location"
    },
    "search": "Search Location / Address",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "table": {
      "header": {
        "address": "Address / URL",
        "campus": "Campuses",
        "name": "Name",
        "status": "Status",
        "type": "Type"
      }
    },
    "title": "Locations",
    "toasts": {
      "createSuccess": "Location created successfully!",
      "updateSuccess": "Location has been updated!"
    }
  },
  "login": {
    "backButton": "Back",
    "enterCodeMessage": "Enter the code we just sent to",
    "enterCodeMessageEmail": "<i>{{email}}</i>",
    "errors": {
      "accountDeactivated": "Your account is no longer active. Contact your manager.",
      "invalidCode": "Please enter a valid verification code",
      "invalidEmail": "Please enter a valid email address",
      "unauthorized": "You are not authorized to access this application."
    },
    "sendSignInCode": "Send Sign-in Code",
    "signIn": "Sign in",
    "signInButton": "Sign in",
    "signInPlaceholder": "Enter your email",
    "title": "Login"
  },
  "payers": {
    "addButton": "New Payer",
    "details": {
      "labels": {
        "billingAddress": "Billing Address",
        "groupType": "Payer Type",
        "invoiceAttentionTo": "Attention To",
        "invoiceDeliveryEmails": "Invoice Delivery Emails",
        "invoiceDeliveryMethod": "Invoice Delivery Method",
        "student": "Student"
      },
      "title": "Payer Details"
    },
    "entity": "payer",
    "filters": {
      "labels": {
        "groupType": "Payer Type"
      },
      "title": "Payer Filters"
    },
    "form": {
      "createSaveButton": "Create Payer",
      "createTitle": "New Payer",
      "errors": {
        "alreadyExists": "A payer with these details already exists.",
        "emailInUse": "A payer with this email already exists.",
        "invalidEmail": "Please enter a valid email address.",
        "nameInUse": "A payer with this name already exists.",
        "unableToCreate": "Unable to create payer: {{error}}",
        "unableToUpdate": "Unable to update payer: {{error}}"
      },
      "labels": {
        "billingAddress": "Billing Address",
        "groupType": "Payer Type",
        "invoiceAttentionTo": "Attention To",
        "invoiceDeliveryEmails": "Invoice Delivery Emails",
        "invoiceDeliveryMethod": "Invoice Delivery Method",
        "name": "Name"
      },
      "nameConflictWarning": "A payer with this name already exists. That's fine — students can share names.",
      "placeholders": {
        "invoiceDeliveryEmails": "Type an email and press Enter"
      },
      "updateSaveButton": "Update Payer",
      "updateTitle": "Edit Payer"
    },
    "search": "Search Payers",
    "table": {
      "header": {
        "email": "Email",
        "groupType": "Type",
        "invoiceDeliveryMethod": "Delivery",
        "name": "Name",
        "phone": "Phone"
      }
    },
    "title": "Payers",
    "toasts": {
      "createSuccess": "Payer created successfully!",
      "updateSuccess": "Payer updated successfully!"
    }
  },
  "products": {
    "addButton": "Add Product",
    "entity": "product",
    "form": {
      "createSaveButton": "Create Product",
      "createTitle": "Add Product",
      "errors": {
        "nameRequired": "Name is required",
        "nameTaken": "A product with this name already exists",
        "unableToCreate": "Unable to create product: {{error}}",
        "unableToUpdate": "Unable to update product: {{error}}"
      },
      "updateSaveButton": "Update Product",
      "updateTitle": "Edit Product"
    },
    "table": {
      "header": {
        "name": "Name"
      }
    },
    "title": "Products",
    "toasts": {
      "createSuccess": "Product created successfully!",
      "updateSuccess": "Product updated successfully!"
    }
  },
  "registrations": {
    "addButton": "Add Registration",
    "description": "This page displays all registrations in the system.",
    "details": {
      "campus": "Campus",
      "cancelButton": "Cancel Registration",
      "classInformation": {
        "alternateClassroomLocation": "Alternate Classroom Location",
        "alternateTrainingLocations": "Alternate Training Locations",
        "classroomLocation": "Classroom Location",
        "title": "{{type}} Classroom Information",
        "toasts": {
          "error": "Failed to update Classroom information",
          "success": "Classroom updated successfully"
        },
        "virtualLocation": "Virtual Zoom.us - Link to be provided"
      },
      "contract": {
        "addButton": "Add Student Contract Information",
        "driverLicence": "Driver's Licence Number",
        "driverLicenceClass": "Driver's Licence Class",
        "driverLicenceExpiry": "Driver's Licence Expiry",
        "middleName": "Student Middle Name",
        "missingField": "{{count}} field missing to generate contract",
        "missingField_plural": "{{count}} fields missing to generate contract",
        "nextOfKinName": "Next of Kin Name",
        "nextOfKinPhoneNumber": "Next of Kin Phone Number",
        "requiredForContract": "Required For Contract",
        "sin": "SIN",
        "sinError": "SIN must be numeric",
        "sinLegacy": "SIN (Legacy)",
        "title": "Student Contract Information"
      },
      "course": {
        "campus": "Campus",
        "endDate": "End Date",
        "name": "Course",
        "startDate": "Start Date",
        "title": "Course Information"
      },
      "generalDocuments": "General Documents",
      "invoiceDrafts": {
        "addButton": "Add Invoice",
        "card": {
          "cancel": "Cancel Invoice",
          "cancelConfirm": {
            "cancel": "Keep Invoice",
            "confirm": "Cancel Invoice",
            "description": "Cancel invoice for {{payerName}}? Payments stay attached and the invoice can be restored later.",
            "title": "Cancel invoice?"
          },
          "delete": "Delete",
          "deleteConfirm": {
            "cancel": "Cancel",
            "confirm": "Delete",
            "description": "Delete invoice for {{payerName}}? This cannot be undone.",
            "title": "Delete invoice?"
          },
          "download": "Download PDF",
          "draft": "Pending",
          "dueDate": "Due Date",
          "edit": "Edit",
          "invoiceDate": "Invoice Date",
          "invoiceDateTbd": "When contract signs (TBD)",
          "items": "Invoice Items",
          "menuLabel": "Invoice actions",
          "nonDraftDisabled": "Only pending invoices can be edited.",
          "onSchedule": {
            "ahead": "Ahead by {{amount}}",
            "behind": "Behind by {{amount}}",
            "onSchedule": "On schedule",
            "paidInFull": "Paid in full"
          },
          "payerType": "Payer Type",
          "paymentLabel": "Payment {{number}}",
          "paymentSchedule": "Payment Schedule",
          "restore": "Restore Invoice",
          "restoreConfirm": {
            "cancel": "Cancel",
            "confirm": "Restore Invoice",
            "description": "Restore invoice for {{payerName}}? Its status will be recomputed from existing payments and the due date.",
            "title": "Restore invoice?"
          },
          "title": "{{payerName}} Invoice",
          "total": "Total"
        },
        "description": "Schedule for future payments to be reflected on customer invoices and contracts.",
        "entity": "invoice",
        "form": {
          "addNewPayer": "New Payer",
          "addPaymentButton": "Add Payment",
          "createStudentPayer": "Create Student Payer",
          "deletePaymentLabel": "Delete payment",
          "difference": "Difference",
          "dueDate": "Due Date",
          "dueDateInfoBody": "defaults to the enrolment start date.",
          "dueDateInfoLabel": "Due date",
          "errors": {
            "scheduleMismatch": "Payment schedule must sum to the invoice total."
          },
          "invoiceDate": "Invoice Date",
          "invoiceDateInfoBody": "is set automatically when the contract is signed.",
          "invoiceDateInfoLabel": "Invoice date",
          "invoiceTotal": "Invoice Total",
          "items": "Invoice Items",
          "payer": "Payer",
          "payerKindLabel": "Who is this invoice for?",
          "payerKindOther": "Another payer",
          "payerKindStudent": "{{name}} (self-pay)",
          "payerPlaceholder": "Search for a payer",
          "payerType": "Payer Type",
          "paymentDate": "Date",
          "paymentLabel": "Payment {{number}}",
          "paymentSchedule": "Payment Schedule",
          "paymentTotal": "Payment Total",
          "studentPayerMissing": "No payer record exists yet for {{name}}. Create one to continue.",
          "title": "New Invoice",
          "updateSaveButton": "Save Changes",
          "updateTitle": "Edit Invoice"
        },
        "placeholder": {
          "description": "Created automatically when a payment was recorded before invoicing existed. Not a customer-facing invoice.",
          "title": "Tracking-only invoice"
        },
        "summary": {
          "difference": "Difference",
          "totalCourseCost": "Total Course Cost",
          "totalInvoices": "Total Invoices"
        },
        "title": "Invoices",
        "toasts": {
          "cancelError": "Unable to cancel invoice: {{error}}",
          "cancelled": "Invoice cancelled",
          "createError": "Unable to create invoice: {{error}}",
          "created": "Invoice created",
          "deleteError": "Unable to delete invoice: {{error}}",
          "deleteHasPaymentsError": "Can't delete an invoice that has payments. Cancel the invoice or remove its payments first.",
          "deleted": "Invoice deleted",
          "downloadError": "Unable to download invoice: {{error}}",
          "downloaded": "Invoice downloaded",
          "locked": "Invoice is locked. Only pending invoices can be modified.",
          "restoreError": "Unable to restore invoice: {{error}}",
          "restored": "Invoice restored",
          "updateError": "Unable to update invoice: {{error}}",
          "updated": "Invoice updated"
        }
      },
      "notes": {
        "addButton": "Add Note",
        "placeholder": "Enter note...",
        "title": "Notes",
        "viewAll": "View All {{count}}"
      },
      "pricing": {
        "taxes": "Taxes",
        "title": "Pricing Details",
        "total": "Total",
        "tuition": "Tuition"
      },
      "requiredDocuments": "Required Documents",
      "restoreButton": "Restore Registration",

      "standing": {
        "false": "No advance standing",
        "title": "Advance Standing"
      },
      "student": {
        "email": "Email",
        "name": "Name",
        "phone": "Phone Number",
        "title": "Student Information"
      },
      "title": "Registration Details",
      "viewEnrolmentDetails": "View Enrolment Details"
    },
    "enrolmentStatus": {
      "active": "Active",
      "cancelled": "Cancelled",
      "completed": "Completed",
      "pending": "Pending",
      "toCertify": "To Certify",
      "uncompleted": "Uncompleted"
    },
    "entity": "registration",
    "filters": {
      "labels": {
        "campus": "Campus",
        "course": "Course",
        "status": "Status"
      },
      "title": "Registration Filters"
    },
    "form": {
      "addNewStudent": "Add New",
      "addProduct": "Add Product",
      "additionalSalesNotes": "Additional Sales Notes",
      "additionalSalesNotesPlaceholder": "Add details about payment arrangements, who is paying for the course, number of expected payments, or any other important information for completing the registration.",
      "advanceStanding": "Advance Standing",
      "advanceStandingDetails": "Advance Standing Details",
      "advanceStandingDetailsPlaceholder": "Enter details about the student’s advanced standing.",
      "campus": "Campus",
      "campusPlaceholder": "Select a campus",
      "course": "Course",
      "courseInformation": "Course Information",
      "coursePlaceholder": "Select a course",
      "createSaveButton": "Add Registration",
      "createTitle": "Add Registration",
      "customProduct": "Custom Product",
      "emptyCoursePricingHint": "Please select a course to view / edit pricing details.",
      "endDate": "End Date",
      "endDateDescription": "Auto-calculated based on course length",
      "errors": {
        "atLeastOneProductRequired": "At least one product is required for registration.",
        "campusRequired": "Campus is required",
        "courseRequired": "Course is required",
        "endDateRequired": "End date is required",
        "startDateRequired": "Start date is required",
        "studentRequired": "Existing student is required or a new student must be added.",
        "unableToCreate": "Unable to create enrolment: {{error}}"
      },
      "existingProduct": "Existing Product",
      "hasAdvanceStanding": "Has Advance Standing",
      "pricingDetails": "Price Details",
      "selectExistingStudent": "Select Existing",
      "startDate": "Start Date",
      "studentInformation": "Student Information",
      "updateTitle": "Edit Registration"
    },
    "registrationStatus": {
      "contractToSend": "Contract to Send",
      "docsDenied": "Docs Denied",
      "docsRequired": "Docs Required",
      "docsToReview": "Docs to Review",
      "signed": "Signed",
      "studentToSign": "Student to Sign"
    },
    "search": "Search Registrations",
    "table": {
      "header": {
        "campus": "Campus",
        "course": "Course",
        "createdAt": "Created At",
        "startDate": "Start Date",
        "status": "Status",
        "student": "Student"
      },
      "invoiceTooltip_one": "{{count}} invoice — {{status}}",
      "invoiceTooltip_other": "{{count}} invoices — {{status}}"
    },
    "title": "Registrations",
    "toasts": {
      "createSuccess": "Enrolment created successfully!",
      "updateStudentContractError": "Failed to update student contract information",
      "updateStudentContractSuccess": "Student contract information has been updated",
      "updateSuccess": "Enrolment has been updated!"
    }
  },
  "reports": {
    "kpiReports": {
      "form": {
        "generateButton": "Generate Reports",
        "period": "Term",
        "periodOptions": {
          "fall": "Fall (Sep-Dec)",
          "summer": "Summer (May-Aug)",
          "winter": "Winter (Jan-Apr)"
        },
        "year": "Year"
      },
      "title": "Enrolment & Graduation KPI Reports"
    },
    "sinBackfill": {
      "description": "Migrate raw SIN values to encrypted storage for all students. Each student's DEK will be generated or reused, and their SIN will be encrypted in batches.",
      "errorMessage": "Migration failed: {{error}}",
      "nothingToMigrate": "All students already have encrypted SINs — nothing to migrate.",
      "progressLabel": "{{migrated}} of {{total}} students migrated",
      "startButton": "Start Migration",
      "successMessage": "Migration complete. {{total}} student(s) successfully encrypted.",
      "title": "SIN Encryption Backfill",
      "warning": "Migration in progress — do not close this page until it completes."
    },
    "title": "Reports"
  },
  "roles": {
    "campus_manager": "Campus Manager",
    "central_manager": "Central Manager",
    "csr": "CSR",
    "instructor": "Instructor",
    "owner": "Owner"
  },
  "selectExistingStudentComponent": {
    "label": "Student",
    "placeholder": "Search Student"
  },
  "sidebar": {
    "calendars": "Calendars",
    "classrooms": "Classrooms",
    "dashboard": "Dashboard",
    "enrolments": "Enrolments",
    "invoices": "Invoices",
    "menuTitle": "All Campuses",
    "payments": "Payments",
    "people": "People",
    "peopleChildren": {
      "payers": "Payers",
      "staff": "Staff",
      "students": "Students"
    },
    "registrations": "Registrations",
    "reports": "Reports",
    "resources": "Resources",
    "resourcesChildren": {
      "campuses": "Campuses",
      "contracts": "Contracts",
      "courses": "Courses",
      "documentTypes": "Document Types",
      "invoices": "Invoices",
      "locations": "Locations",
      "products": "Products",
      "vehicles": "Vehicles"
    },
    "settings": "Settings",
    "settingsChildren": {
      "glCodes": "GL Codes",
      "payerGroups": "Payer Groups"
    }
  },
  "staff": {
    "addButton": "Add Staff",
    "details": {
      "alerts": {
        "description": "If you deactivate {{firstName}}'s profile they will loose access to their account and won't be able to use it until they have their profile active again.\n\nYou can revert this action by reactivating their profile on the Staff page.",
        "title": "Do you want to deactivate {{name}}?"
      },
      "deactivateProfile": "Deactivate Profile",
      "labels": {
        "campus": "Associated campuses",
        "role": "Role",
        "status": "Status"
      },
      "title": "Staff Details"
    },
    "entity": "staff",
    "filters": {
      "labels": {
        "roles": "Roles",
        "status": "Status"
      },
      "title": "Staff Filters"
    },
    "form": {
      "createSaveButton": "Create & Invite Staff",
      "createTitle": "Add Staff",
      "errors": {
        "atLeastOneCampusRequired": "At least one campus is required",
        "emailInUse": "Email is already in use!",
        "lastActiveOwner": "Cannot deactivate the last active owner.",
        "roleRequired": "Role is required",
        "staffNotFound": "Staff member not found",
        "unableToCreate": "Unable to create staff member: {{error}}"
      },
      "info": {
        "centralManagerCampuses": "Central Managers have read, edit, and add access to all campuses",
        "csrCampuses": "CSRs have read access to all campuses",
        "instructorCampuses": "Instructors have read access to all campuses",
        "ownerCampuses": "Owners have read, edit, and add access to all campuses"
      },
      "updateSaveButton": "Update Staff",
      "updateTitle": "Edit Staff"
    },
    "search": "Search Staff",
    "table": {
      "header": {
        "campus": "Campuses",
        "name": "Name",
        "role": "Role",
        "status": "Status"
      }
    },
    "title": "Staff",
    "toasts": {
      "activateSuccess": "{{name}}'s account has been activated",
      "createSuccess": "Staff member created successfully!",
      "deactivateSuccess": "{{name}}'s account has been deactivated",
      "updateSuccess": "{{name}} has been updated"
    }
  },
  "students": {
    "addButton": "Add Student",
    "details": {
      "alerts": {
        "description": "You are about to invite {{name}} to the student platform. They will receive an email with login information to our platform. This action cannot be undone.",
        "title": "Invite student"
      },
      "inviteStudent": "Invite Student",
      "labels": {
        "address": "Address",
        "phone": "Phone Number",
        "status": "Status"
      },
      "title": "Student Details"
    },
    "entity": "student",
    "filters": {
      "labels": {
        "status": "Status"
      },
      "title": "Student Filters"
    },
    "form": {
      "createSaveButton": "Add Student",
      "createTitle": "Add Student",
      "errors": {
        "studentNotFound": "Student not found",
        "unableToCreate": "Unable to create student: {{error}}"
      },
      "sendCreationInvite": "Send invite upon creation",
      "updateSaveButton": "Update Student",
      "updateTitle": "Edit Student"
    },
    "search": "Search Students",
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "invited": "Invited",
      "notInvited": "Not Invited"
    },
    "table": {
      "header": {
        "created": "Created",
        "name": "Name",
        "status": "Status"
      }
    },
    "title": "Students",
    "toasts": {
      "createSuccess": "Student created successfully!",
      "inviteSuccess": "{{name}} has been invited",
      "updateSuccess": "{{name}} has been updated"
    }
  },
  "tabs": {
    "previous": "Previous",
    "today": "Today",
    "upcoming": "Upcoming"
  },
  "vehicles": {
    "addButton": "Add Vehicle",
    "details": {
      "alerts": {
        "deactivateDescription": "This action will deactivate the vehicle and remove it from future event options.",
        "deactivateTitle": "Do you want to deactivate {{name}}?",
        "reactivateDescription": "This action will reactivate the vehicle and make it available for future event options.",
        "reactivateTitle": "Do you want to reactivate {{name}}?"
      },
      "labels": {
        "name": "Name",
        "plate": "Plate",
        "status": "Status",
        "vehicleType": "Vehicle Type"
      },
      "title": "Vehicle Details"
    },
    "entity": "vehicle",
    "filters": {
      "labels": {
        "status": "Status",
        "vehicleType": "Vehicle Type"
      },
      "title": "Vehicle Filters"
    },
    "form": {
      "createSaveButton": "Create Vehicle",
      "createTitle": "Add Vehicle",
      "duplicatePlateDialog": {
        "cancelButton": "Go Back",
        "confirmButton": "Proceed Anyway",
        "description": "A vehicle with plate \"{{plate}}\" already exists. Are you sure you want to proceed?",
        "title": "Duplicate Plate Number"
      },
      "errors": {
        "nameInUse": "A vehicle with this name already exists.",
        "plateInUse": "A vehicle with this plate already exists.",
        "unableToCreate": "Unable to create vehicle: {{error}}",
        "unableToUpdate": "Unable to update vehicle: {{error}}",
        "vehicleNotFound": "Vehicle not found."
      },
      "labels": {
        "name": "Name",
        "plate": "Plate",
        "vehicleType": "Vehicle Type"
      },
      "odometerEnd": "Odometer / Hour Meter End",
      "odometerStart": "Odometer / Hour Meter Start",
      "placeholder": "Select vehicles",
      "updateSaveButton": "Update Vehicle",
      "updateTitle": "Edit Vehicle"
    },
    "search": "Search Vehicles",
    "table": {
      "header": {
        "name": "Name",
        "plate": "Plate",
        "status": "Status",
        "vehicleType": "Type"
      }
    },
    "title": "Vehicles",
    "toasts": {
      "activateSuccess": "{{name}} has been reactivated.",
      "createSuccess": "Vehicle created successfully.",
      "deactivateSuccess": "{{name}} has been deactivated.",
      "updateSuccess": "Vehicle updated successfully."
    }
  }
}
